import { Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Shimmer from '~/components/Shimmer';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { InternalNewsDetail } from '~/features/InternalNewsDetail';
import { InternalNewsDetailHeader } from '~/features/InternalNewsDetailHeader';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

/**
 * 社内報詳細 Screen
 */
export const Screen: React.FC = () => {
  const { id = '' } = useParams<{ id: string }>();

  const newsId = Number.parseInt(id, 10);
  if (Number.isNaN(newsId)) {
    return <Navigate to={ROUTES.INTERNAL_NEWS.INDEX} replace />;
  }

  return (
    <div className={styles.screen}>
      <ClientSideMenu />
      <div className={styles.content}>
        <Suspense fallback={<Shimmer />}>
          <InternalNewsDetailHeader newsId={newsId} />
          <main className={styles.body}>
            <InternalNewsDetail newsId={newsId} />
          </main>
        </Suspense>
      </div>
    </div>
  );
};
